import React from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useProgramById } from './useProgramById';
import EnrolledProgramView from './components/EnrolledProgramView';
import messages from './messages';

import './index.scss';

const Programs = () => {
  const intl = useIntl();
  const { programId: rawProgramId } = useParams();
  const programId = decodeURIComponent(rawProgramId || '');

  const { program, loading, error } = useProgramById(programId);

  if (loading) {
    return (
      <div className="program-inner__state">
        <Spinner
          animation="border"
          screenReaderText={intl.formatMessage(messages.loadingProgram)}
        />
      </div>
    );
  }

  if (error || !program) {
    return (
      <div className="program-inner__state program-inner__state--error">
        {intl.formatMessage(messages.programLoadError)}
      </div>
    );
  }

  return <EnrolledProgramView program={program} />;
};

export default Programs;
